<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="来源通道" class="EL-Form-Item">
                        <el-select v-model="prodTaskSearch.lineCode" placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in warehouseList" :key="item.whId" :label="item.whCode+'-'+item.whName" :value="item.whCode">{{item.whCode}}-{{item.whName}}
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="任务状态" class="EL-Form-Item">
                        <el-select multiple collapse-tags v-model="taskStatusList" clearable="clearable">
                            <!-- <el-option key="6" value="START,EXECUTE" label="默认(任务开始、进行中)"></el-option> -->
                            <el-option key="1" value="START" label="任务开始"></el-option>
                            <el-option key="2" value="EXECUTE" label="任务进行中"></el-option>
                            <el-option key="3" value="CANCEL" label="任务取消"></el-option>
                            <el-option key="4" value="COMPLETE" label="任务正常完成"></el-option>
                            <el-option key="5" value="WARNCOMP" label="任务异常"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="prodTaskSearch.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="pickerOptions0"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="prodTaskSearch.fcCode">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="prodTaskSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="clickSelectList()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="ProdTaskReset()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="!prodTaskSearch.fcCode">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="prodTaskSearch.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
        </box>
        <box fill>
            <plabel text="成品搬运">
                <el-button class="btn-t-edit" v-authority="'BACK_MENU1_M7_B1'" @click="showInsertProdTaskDialog">
                    新增
                </el-button>
                <el-button v-authority="'BACK_MENU1_M7_B2'" class="btn-t-edit" @click="isReceivingDetails = true">工单同步</el-button>
                <el-button class="btn-t-edit" v-if="(this.personWhCode == '01') || (this.personWhCode == '04')" v-authority="'BACK_MENU1_M7_B7'" @click="showPointPullDialog">
                    点对点搬运
                </el-button>
                <el-button class="btn-t-edit" v-authority="'BACK_MENU1_M7_B3'" @click="cancelTask">
                    取消任务
                </el-button>
                <el-button class="btn-t-edit" v-authority="'BACK_MENU1_M7_B4'" @click="untieOccupyClick">
                    解绑和占用
                </el-button>
                <el-button :loading="downloadLoading" class="btn-t-edit" v-authority="'BACK_MENU1_M7_B5'" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="prodTaskData.headerCellStyle" style="flex: 1" @pageChange="getProdTaskByProductType" :data="prodTaskData.data" pagination :nowPage.sync="prodTaskData.pageNum" :pageSize.sync="prodTaskData.pageSize" :total.sync="prodTaskData.total" @selectionChange="selectAllProdTask">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="来源通道" prop="lineCode" align="center">
                </el-table-column>
                <el-table-column label="任务编号" prop="taskCode" align="center">
                </el-table-column>
                <el-table-column label="任务类型" prop="taskType" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.taskType == 'PRODUCT'">成品下线</span>
                        <span v-if="scope.row.taskType == 'EMPTYBOX'">包材上线</span>
                        <span v-if="scope.row.taskType == 'POINTPULL'">点对点搬运</span>
                    </template>
                </el-table-column>
                <el-table-column label="任务状态" prop="taskStatus" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.taskStatus == 'START'">任务开始</span>
                        <span v-if="scope.row.taskStatus == 'EXECUTE'">任务进行中</span>
                        <span v-if="scope.row.taskStatus == 'CANCEL'">任务取消</span>
                        <span v-if="scope.row.taskStatus == 'COMPLETE'">任务正常完成</span>
                        <span v-if="scope.row.taskStatus == 'WARNCOMP'">任务异常</span>
                    </template>
                </el-table-column>
                <el-table-column label="当前任务描述" prop="nowTcDesc" align="center">
                </el-table-column>
                <el-table-column label="任务执行点" prop="taskPathPoint" align="center">
                </el-table-column>
                <el-table-column label="任务终点" prop="taskFinishPoint" align="center">
                </el-table-column>
                <el-table-column label="AGV是否接收任务" prop="agvFlag" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.agvFlag == true">是</span>
                        <span v-if="scope.row.agvFlag == false">否</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" prop="createTime" align="center" width="140px">
                </el-table-column>
                <el-table-column label="物料编号" prop="prodCode" align="center">
                </el-table-column>
                <el-table-column label="箱体类型" prop="boxType" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.boxType == 'AP2'">一期成品二层箱</span>
                        <span v-if="scope.row.boxType == 'AP1'">一期成品一层箱</span>
                        <span v-if="scope.row.boxType == 'AA'">大托盘</span>
                        <span v-if="scope.row.boxType == 'BB'">二期蓝色一层箱</span>
                        <span v-if="scope.row.boxType == 'BP2'">二期成品二层箱</span>
                        <span v-if="scope.row.boxType == 'BP1'">二期成品一层箱</span>
                    </template>
                </el-table-column>
                <el-table-column label="容器类型" prop="cntrType" align="center">
                </el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU1_M7_B6'" class="btn-t-select" @click="showProdTaskDetailDialog(scope.row.taskCode)" v-if="scope.row.taskType == 'PRODUCT'">明细</el-button>
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 点对点搬运 -->
        <el-dialog class="fromDialog" :style="$popups.popups(0.4,0.3)" title="点对点搬运" :visible.sync="pointPullDialog" @close="closePointPullDialog">
            <div style="font-size: 16px;overflow:hidden">
                <el-form label-width="100px">
                    <el-col :lg="10" :xl="10">
                        <el-form-item label="搬运起点" class="EL-Form-Item">
                            <el-select v-model="pointStart" placeholder="请选择" filterable clearable="clearable">
                                <el-option v-for="item in startPointList" :key="item.point" :label="item.lrName" :value="item.point">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="10" :xl="10">
                        <el-form-item label="搬运终点" class="EL-Form-Item">
                            <el-select v-model="pointEnd" placeholder="请选择" filterable clearable="clearable">
                                <el-option v-for="item in endPointList" :key="item.point" :label="item.lrName" :value="item.point">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="10" :xl="10">
                        <el-form-item label="箱号" class="EL-Form-Item">
                            <el-input v-model="boxCode" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closePointPullDialog()" class="btn-t-info">取 消</el-button>
                <el-button :loading="insertPointPullLoading" class="btn-t-edit" @click="insertPointPull()">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 包材上线 -->
        <el-dialog class="fromDialog" :style="$popups.popups(0.4,0.3)" title="包材上线" :visible.sync="packingMaterialDialog" @close="closePackingMaterialDialog">
            <div style="font-size: 16px;overflow:hidden">
                <el-form label-width="100px">
                    <el-col :lg="10" :xl="10">
                        <el-form-item label="库位编号" class="EL-Form-Item">
                            <el-select v-model="packageCode" placeholder="请选择">
                                <el-option v-for="item in sysLineRouterList" :key="item.whId" :label="item.lrRealCode" :value="item.lrRealCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="10" :xl="10">
                        <el-form-item label="所需包材类型" class="EL-Form-Item">
                            <el-select v-model="packageType" placeholder="请选择">
                                <el-option value="类型1" label="类型1"></el-option>
                                <el-option value="类型2" label="类型2"></el-option>
                                <el-option value="类型3" label="类型3"></el-option>
                                <el-option value="类型4" label="类型4"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closePackingMaterialDialog()" class="btn-t-info">取 消</el-button>
                <el-button :loading="insertProdTasks" class="btn-t-edit" @click="emptyBoxOnline()">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 新增成品箱 -->
        <el-dialog class="fromDialog" :style="$popups.popups(0.7,0.35)" title="新增成品箱" :close-on-click-modal="false" :visible.sync="insertProductDialog" @close="closeProductDialog">
            <div style="font-size: 16px;overflow:hidden">
                <el-form label-width="80px">
                    <el-col :lg="7" :xl="7">
                        <el-form-item label="工单" class="EL-Form-Item">
                            <el-select v-model="productData.opCode" filterable clearable="clearable">
                                <el-option v-for="item in orderList" :key="item.opId" :value="item.opCode" :label="item.opCode+'——'+item.matCode+'——'+item.matQuan+'——'+item.schduleStartDate"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :offset="1" :lg="7" :xl="7">
                        <el-form-item label="围板箱编码" class="EL-Form-Item">
                            <el-select v-model="productData.packCode" filterable>
                                <el-option v-for="item in enclosureCodeList" :key="item.lpId" :value="item.packCode" :label="item.packCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :offset="1" :lg="7" :xl="7">
                        <el-form-item label="包装方式" class="EL-Form-Item">
                            <el-select v-model="productData.packageCode" filterable>
                                <el-option v-for="item in packingMethodList" :key="item.lpId" :value="item.packCode" :label="item.packCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="7" :xl="7">
                        <el-form-item label="每托数量" class="EL-Form-Item">
                            <el-input v-model="productData.matQuan" placeholder="请输入" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :offset="1" :lg="7" :xl="7">
                        <el-form-item label="规值" class="EL-Form-Item">
                            <el-input v-model="productData.matSpecs" placeholder="请输入"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :offset="1" :lg="7" :xl="7">
                        <el-form-item label="托数" class="EL-Form-Item">
                            <el-input v-model="productData.boxNumber" placeholder="请输入" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeProductDialog()" class="btn-t-info">取 消</el-button>
                <el-button :loading="productLoading" class="btn-t-edit" @click="insertProduct()">配 送</el-button>
            </span>
        </el-dialog>

        <!-- 新增成品搬运 -->
        <el-dialog class="fromDialog" :style="$popups.popups(0.8,0.9)" title="新增成品搬运" :visible.sync="insertProdTaskDialog">
            <div style="font-size: 16px">
                <el-form label-width="80px">
                    <el-col :lg="5" :xl="5" v-if="fcCode == 'SXC'">
                        <el-form-item label="库位编号" class="EL-Form-Item">
                            <el-select v-model="lineCode" placeholder="请选择">
                                <el-option v-for="item in sysLineRouterOutPuts" :key="item.whId" :label="item.lrName" :value="item.lrRealCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="箱体类型" class="EL-Form-Item">
                            <el-select v-model="prBoxType" placeholder="请选择">
                                <div v-if="whCodeData.whArea == '1'">
                                    <el-option value="AP2" label="一期成品二层箱"></el-option>
                                    <el-option value="AP1" label="一期成品一层箱"></el-option>
                                    <el-option value="AA" label="大托盘"></el-option>
                                </div>
                                <div v-else-if="whCodeData.whArea == '2'">
                                    <el-option value="BB" label="二期蓝色一层箱"></el-option>
                                    <el-option value="BP2" label="二期成品二层箱"></el-option>
                                    <el-option value="BP1" label="二期成品一层箱"></el-option>
                                </div>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="配送方式" class="EL-Form-Item" v-if="fcCode == 'SXC'">
                            <el-select v-model="shipping" placeholder="请选择">
                                <el-option value="agv" label="AGV配送"></el-option>
                                <el-option value="artificial" label="人工配送"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="5" :xl="5">
                        <el-form-item label="配送方式" class="EL-Form-Item" v-if="fcCode == 'DLN'">
                            <el-select v-model="shipping" placeholder="请选择">
                                <el-option value="artificial" label="人工配送"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="9" :xl="9" v-if="fcCode == 'SXC'">
                        <div style="float:right">
                            <el-button class="btn-t-edit" @click="openProductDialog">
                                新增成品箱
                            </el-button>
                        </div>
                    </el-col>
                    <el-col :lg="14" :xl="14" v-if="fcCode == 'DLN'">
                        <div style="float:right">
                            <el-button class="btn-t-edit" @click="openProductDialog">
                                新增成品箱
                            </el-button>
                        </div>
                    </el-col>
                </el-form>
                <h-table :style="$popups.harvestRecordStyle(0.7)" :headerCellStyle="prodTaskDetails.headerCellStyle" style="flex: 1" @pageChange="getProdTaskDetailByCreate" :data="prodTaskDetails.data" pagination :nowPage.sync="prodTaskDetails.pageNum" :pageSize.sync="prodTaskDetails.pageSize" :total.sync="prodTaskDetails.total" @selectionChange="selectAllProdTaskDetail">
                    <el-table-column type="selection" align="center"></el-table-column>
                    <el-table-column label="通道编号" prop="whCode" align="center">
                    </el-table-column>
                    <el-table-column label="成品编号" prop="matCode" align="center">
                    </el-table-column>
                    <el-table-column label="成品数量" prop="matQuan" align="center">
                    </el-table-column>
                    <el-table-column label="箱号" prop="boxBarcode" align="center">
                    </el-table-column>
                    <el-table-column label="围板箱编码" prop="packCode" align="center">
                    </el-table-column>
                    <el-table-column label="包装方式" prop="packageCode" align="center">
                    </el-table-column>
                    <el-table-column label="工单编号" prop="opCode" align="center">
                    </el-table-column>
                    <el-table-column label="规值" prop="matSpecs" align="center">
                    </el-table-column>
                    <el-table-column label="状态" prop="status" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 'CREATE'">创建</span>
                            <span v-if="scope.row.status == 'EXECUTE'">搬运中</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建时间" prop="createTime" align="center" width="150px">
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="160">
                        <template slot-scope="scope">
                            <el-button @click="rePrintBarcode(scope.row)" class="btn-t-info">打印</el-button>
                            <el-button @click="deleteProdTaskDetail(scope.row.tdId)" class="btn-t-delete">删除</el-button>
                        </template>
                    </el-table-column>
                </h-table>
            </div>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeProdTaskDetailDialog()" class="btn-t-info">取 消</el-button>
                <el-button :loading="insertProdTasks" class="btn-t-edit" @click="insertProdTask()">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 成品搬运详情 -->
        <el-dialog class="fromDialog" :style="$popups.popups(0.8,0.8)" title="成品搬运详情" :visible.sync="prodTaskDetailDialog">
            <h-table :style="$popups.harvestRecordStyle(0.65)"  :headerCellStyle="prodTaskDetailData.headerCellStyle" :data="prodTaskDetailData.data">
                <el-table-column label="通道编号" prop="whCode" align="center">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center">
                </el-table-column>
                <el-table-column label="物料数量" prop="matQuan" align="center">
                </el-table-column>
                <el-table-column label="箱号" prop="boxBarcode" align="center">
                </el-table-column>
                <el-table-column label="任务编号" prop="taskCode" align="center" width="180px">
                </el-table-column>
                <el-table-column label="任务类型" prop="taskType" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.taskType == '10'">成品</span>
                        <span v-if="scope.row.taskType == '20'">退料</span>
                    </template>
                </el-table-column>
                <el-table-column label="工单编号" prop="opCode" align="center">
                </el-table-column>
                <el-table-column label="规值" prop="matSpecs" align="center">
                </el-table-column>
                <el-table-column label="创建时间" prop="createTime" align="center">
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="returnClose" type="info" class="btn-t-info">关 闭</el-button>
            </div>
        </el-dialog>


        <!-- 解绑和占用 -->
        <el-dialog class="fromDialog" :style="$popups.popups(0.4,0.6)" title="库位详情" :visible.sync="untieOccupyDialog">
            <div style="font-size: 16px;float:right;margin: 5px 0px">
                <el-button class="btn-t-edit" @click="occupyClick">
                    占用
                </el-button>
                <el-button class="btn-t-delete" @click="untieClick">
                    解绑
                </el-button>
            </div>
            <!--  @selectionChange="checkSysPointList" -->
            <h-table :headerCellStyle="untieOccupyData.headerCellStyle" :style="$popups.harvestRecordStyle(0.4)" :data="untieOccupyData.data">
                <el-table-column label="点位">
                    <template slot-scope="scope">
                        <el-radio :label="scope.row.lrRealCode" v-model="untieOccupyRadio" />
                    </template>
                </el-table-column>
                <el-table-column label="点位名称" prop="lrName" align="center" />
                <el-table-column label="点位状态" prop="occupyFlag" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.occupyFlag == true">占用</span>
                        <span v-if="scope.row.occupyFlag == false">空闲</span>
                    </template>
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="untieOccupyDialog = false" type="info" class="btn-t-info">关 闭</el-button>
            </div>
        </el-dialog>

        <!-- 工单同步 -->
        <el-dialog title="工单同步" :visible.sync="isReceivingDetails" class="fromDialog" :style="$popups.popups(0.2,0.25)" :close-on-click-modal="false" :show-close="false" @click.stop>
            <el-form label-position="right" label-width="80px">
                <el-form-item label="工单编号" prop="tableOrderCode" class="EL-Form-Item" >
                    <el-input v-model="tableOrderCode" placeholder="请输入">
                        </el-input>
                </el-form-item>
            </el-form>
        
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="isReceivingDetails = false" class="btn-t-info">取 消</el-button>
                <el-button @click="synchronization()" class="btn-t-edit">确 认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        name: "FinishedProductHanding",
        data() {
            return {
                untieOccupyRadio: "",
                prodTaskData: {
                    data: [],
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                prodTaskSearch: {
                    fcCode: localStorage.getItem("fcCode") || "",
                    lineCode: localStorage.getItem("whCode") || "",
                    taskStatus: "",
                    date: [],
                },
                whCodeId: "",

                prodTaskDetailData: {
                    data: [],
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },

                //任务状态集合
                taskStatusList: ["START", "EXECUTE"],
                //明细成品任务记录窗口
                prodTaskDetailDialog: false,
                //成品搬运任务编号
                taskCode: "",
                //新增成品搬运记录窗口
                insertProdTaskDialog: false,
                //工厂通道产线下料口
                sysLineRouterOutPuts: [],
                //成品搬运对象集合
                prodTaskDetails: {
                    data: [],
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                //成品搬运的库位编号
                lineCode: "",
                //箱体类型
                prBoxType: "",
                //成品搬运的箱号
                boxBarcode: "",
                // 解绑和占用弹出框
                untieOccupyData: {
                    data: [],
                    pageNum: 1,
                    pageSize: 20,
                    total: 0,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                untieOccupyDialog: false,


                //成品装车物料
                productPullDetail: "",
                //成品装车库位编号
                laCode: "",
                //工厂编号
                fcCode: localStorage.getItem("fcCode") || "",
                //操作人
                person: localStorage.getItem("user"),
                //操作人工号
                personNumber: localStorage.getItem("empNumber"),
                personWhCode: localStorage.getItem("whCode"),
                whCode: "",
                //来源通道集合
                whCodeList: [],
                warehouseList: [],
                //发往地
                address: "",
                //成品搬运任务复选项
                checkList: [],
                //复选项
                checkListMain: [],
                //选中任务集合
                prodTaskDetailList: [],

                //包材上线窗口
                packingMaterialDialog: false,
                //包材产线点集合
                sysLineRouterList: [],
                //包材上线库位编号
                packageCode: "",
                //所需包材类型
                packageType: "",
                //配送方式
                shipping: "agv",
                //包材上线按钮动态加载
                insertPackageTask: false,

                //新增成品箱窗口
                insertProductDialog: false,
                //新增成品箱动态加载
                productLoading: false,
                //工单集合
                orderList: [],
                //包装方式集合
                packingMethodList: [],
                // 围板箱编号集合
                enclosureCodeList: [],
                //成品箱对象
                productData: {
                    //opCodeAndMatCode:"",
                    opCode: "", //订单编号
                    matQuan: "", //成品数量
                    whCode: localStorage.getItem("whCode") || "", //通道
                    packCode: "", //箱编号
                    packageCode: "", //包装编号
                    matSpecs: "", //规值
                    boxNumber: "", //箱子数量
                    fcCode: localStorage.getItem("fcCode") || "", //工厂编号
                },
                //多选对象
                checkDetailList: [],
                //通道对象
                whCodeData: {},
                //规值是否显示
                showMatSpecs: false,
                //搬运几箱定义对象
                handlingRules: [{
                        "type": "AP2",
                        "name": "一期成品二层箱",
                        "number": "1"
                    },
                    {
                        "type": "AP1",
                        "name": "一期成品一层箱",
                        "number": "2"
                    },
                    {
                        "type": "AA",
                        "name": "大托盘",
                        "number": "1"
                    },
                    {
                        "type": "BB",
                        "name": "二期蓝色一层箱",
                        "number": "2"
                    },
                    {
                        "type": "BP2",
                        "name": "二期成品二层箱",
                        "number": "1"
                    },
                    {
                        "type": "BP1",
                        "name": "二期成品一层箱",
                        "number": "1"
                    },
                ],
                //箱体类型规格
                boxTypeData: {

                },
                //点对点搬运窗口
                pointPullDialog: false,
                //存放起点
                startPointList: [],
                //存放终点
                endPointList:[],
                //点对点搬运起点
                pointStart: "",
                //点对点搬运终点
                pointEnd: "",
                //搬运箱
                boxCode: "",
                //点对点按钮响应
                insertPointPullLoading: false,

                downloadLoading: false, //下载中
                insertProdTasks: false,

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注

                lazyNext: null, //打印
                // 输入框延时加载
                isSetTimeout: null,

                //占用和解绑提示是否存在任务
                prodTaskLoading: "",

                //工单窗口
                isReceivingDetails: false,
                //工单编号
                tableOrderCode: "",
                timer:"",
            };
        },
        watch: {
            prodTaskSearch: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectList(newVal);
                    }, 1000);
                },
                deep: true,
            },
            taskStatusList: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.clickSelectList(newVal);
                    }, 1000);
                },
                deep: true,
            },
            // prodTaskData: {
            //     handler(newVal) {
            //         clearTimeout(this.isSetTimeout)
            //         this.isSetTimeout = setTimeout(() => {
            //             this.clickSelectList();
            //         }, 20000);
            //     },
            //     deep: true,
            // }
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.prodTaskSearch.date[0]) {
                            return time.getTime() < new Date(_this.prodTaskSearch.date[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.prodTaskSearch.date[1]) {
                            return time.getTime() > new Date(_this.prodTaskSearch.date[1]);
                        }
                    }
                }
            },
        },
        methods: {
            // 节流搜索
            saveSearch() {
                if (window.lazy) window.clearTimeout(window.lazy)
                window.lazy = window.setTimeout(() => {
                    this.clickSelectList()
                }, 1000)
            },
            //同步工单
            synchronization(){
                if(this.tableOrderCode == "" || this.tableOrderCode.length != 7){
                    this.$message({
                        message: "请填写正确的工单编号!",
                        type: "warning",
                    });
                    return
                }
                this.$http
                    .request({
                        url: "/api/order/opCodeSynchronization",
                        method: "POST",
                        showLoading: true,
                        params:{
                            opCode:this.tableOrderCode
                        }
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.isReceivingDetails = false
                            this.tableOrderCode = "";
                            this.$message({
                                message: "同步成功",
                                type: "success",
                            });
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    })
            },
            /**
             * 新增点对点搬运
             */
            insertPointPull() {
                this.insertPointPullLoading = true;
                this.$http
                    .request({
                        url: "/agv/taskWhole/createPointToPointTask",
                        method: "POST",
                        params: {
                            startPoint: this.pointStart || null,
                            endPoint: this.pointEnd || null,
                            boxbarcodes: this.boxCode || null,
                            personNumber: localStorage.getItem("empNumber"),
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.closePointPullDialog();
                            this.insertPointPullLoading = false;
                            this.$message({
                                message: "点对点开始搬运！",
                                type: "success",
                            });
                        } else {
                            this.insertPointPullLoading = false;
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
            },
            /**
             * 查询工厂1、4通道半成品位置
             */
            getSysLineAndPointRouterAll() {
                this.$http
                    .request({
                        url: "/api/sysPointRouter/getSysLineRouterByWhCode",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "", //	当前登录的工厂
                            whCode: localStorage.getItem("whCode") || "",
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.startPointList = res.data.list || [];
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
            },
            /**
             * 查询工厂1、4通道半成品位置
             */
            getSysLineRouterByWhCodeCH() {
                this.$http
                    .request({
                        url: "/api/sysPointRouter/getSysLineRouterByWhCodeCH",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "", //	当前登录的工厂
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.endPointList = res.data.list || [];
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
            },
            /**
             * 关闭点对点搬运窗口
             */
            closePointPullDialog() {
                this.pointStart = "";
                this.pointEnd = "";
                this.boxCode = "";
                this.pointPullDialog = false;
            },
            /**
             * 打开点对点搬运窗口
             */
            showPointPullDialog() {
                this.getSysLineAndPointRouterAll();
                this.getSysLineRouterByWhCodeCH();
                this.pointPullDialog = true;
            },
            /**
             * 截取工单和物料
             */
            productChange() {
                var arr = this.productData.opCodeAndMatCode.split("-");
                var matCodeList = ["RC", "RS", "RQ", "RU"];
                var matCode = arr[1];
                var flag = false;
                this.productData.opCode = arr[0];
                matCodeList.forEach((item) => {
                    if (item == matCode.substring(0, 2)) {
                        flag = true;
                    }
                })
                if (flag) {
                    this.showMatSpecs = true;
                } else {
                    this.showMatSpecs = false;
                }
            },
            /**
             * 根据通道获取该出厂成品箱是一期的还是二期的
             */
            getWhAreaByWhCode() {
                this.$http
                    .request({
                        url: "/api/sysWarehouse/getWhAreaByWhCode",
                        method: "GET",
                        params: {
                            whCode: this.productData.whCode || null,
                            fcCode: localStorage.getItem("fcCode") || "", //	当前登录的工厂
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.whCodeData = res.data[0] || null;
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
            },
            /**
             * 任务异常完成
             */
            abnormalCompletion() {
                if (this.checkList.length < 1) {
                    this.$message({
                        message: "请勾选一个任务再进行任务异常完成操作！",
                        type: "warning",
                    });
                    return;
                } else if (this.checkList.length != 1) {
                    this.$message({
                        message: "只能对一个成品搬运任务进行任务异常完成操作！",
                        type: "warning",
                    });
                    return;
                }
                if (this.checkList[0].status == 'COMPLETE') {
                    this.$message({
                        message: "完成状态的任务不能进行任务异常完成操作！",
                        type: "warning",
                    });
                    return;
                } else if(this.checkList[0].taskStatus != 'START' && this.checkList[0].taskStatus != "EXECUTE"){
                    this.$message({
                        message: "只能对开始和进行中状态的任务进行异常完成任务！",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$confirm("是否确认该任务为异常完成吗?", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.$http
                                .request({
                                    url: "/agv/task/warnCompleteTask",
                                    method: "POST",
                                    params: {
                                        taskCode: this.checkList[0].taskCode,
                                    },
                                })
                                .then((resp) => {
                                    if (resp.status == 100) {
                                        this.getProdTaskByProductType();
                                        this.$message({
                                            message: "任务异常完成成功",
                                            type: "success",
                                        });
                                    } else {
                                        this.$message({
                                            message: "操作失败",
                                            type: "warning",
                                        });
                                    }
                                })
                                .catch((error) => {
                                    this.$message({
                                        message: "操作失败",
                                        type: "warning",
                                    });
                                });
                        }).catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });
                }
            },
            /**
             * 删除成品箱
             */
            deleteProdTaskDetail(tdId) {
                this.$confirm("是否确认删除该成品箱数据吗?", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/SplitMergeMatChange/deleteProdTaskDetail",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    tdIds: tdId,
                                    fcCode: this.fcCode,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.getProdTaskDetailByCreate();
                                    this.$message({
                                        message: "操作成功",
                                        type: "success",
                                    });
                                } else {
                                    this.$message({
                                        message: "操作失败",
                                        type: "warning",
                                    });
                                }
                            })
                            .catch((error) => {
                                this.$message({
                                    message: "操作失败",
                                    type: "warning",
                                });
                            });
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    });
            },

            //标签补打
            rePrintBarcode(returnData) {

                //无码时添加打印限制
                if (this.lazyNext) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {

                    //打印成品标签
                    var produceTime = moment(returnData.createTime).format("YYYYMMDD");

                    var batchNo = 'P' + returnData.opCode;

                    if (returnData.matSpecs == undefined) {
                        returnData.matSpecs = "";
                    }

                    //T/生产工单/箱号/物料号/数量/规值/批次/生产日期/高度/箱型
                    // var qrCode = "T/" + returnData.opCode + "/" + returnData.boxBarcode + "/" + returnData.matCode + "/" +
                    //     returnData.matQuan + "/" + returnData.matSpecs + "/" + batchNo +
                    //     "/" + produceTime + "/" + "/" + returnData.packCode;

                    //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                    var qrCode = returnData.boxBarcode + "," + returnData.opCode + "," + returnData.whCode + "," +
                        returnData.matCode + "," + returnData.matQuan + "," + returnData.matSpecs +
                        "," + batchNo + "," + produceTime + "," + returnData.boxHeight + ",,,";

                    var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                    var barcodeData = {
                        boxBarcode: returnData.boxBarcode,
                        prodCode: returnData.matCode,
                        prodName: returnData.matName,
                        batchNo: batchNo,
                        count: returnData.matQuan,
                        checkPerson: localStorage.getItem("empNumber"),
                        date: produceTime,
                        poCode: returnData.opCode,
                        matSpecs: returnData.matSpecs,
                        whCode: returnData.whCode,
                        qrCode: qrCode,
                        supply: "",
                        printTime: printTime,
                        packageCode: returnData.packageCode,
                        packCode: returnData.packCode,
                        com: returnData.com,
                    }

                    this.$printer.printWMSProductBarcode(barcodeData);


                    this.lazyNext = setTimeout(() => {
                        this.lazyNext = null
                    }, 5000)
                }
            },

            /**
             * 查询围板箱编码数据
             */
            enclosureCode() {
                this.$http
                    .request({
                        url: "/api/sysLinePackage/getSysLinePackageList",
                        method: "GET",
                        params: {
                            lineCode: localStorage.getItem("whCode") || "",
                            fcCode: localStorage.getItem("fcCode") || "", //	当前登录的工厂
                            lpType: "10"
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.enclosureCodeList = res.data;
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
            },

            /**
             * 查询包装方式
             */
            packingMethod() {
                this.$http
                    .request({
                        url: "/api/sysLinePackage/getSysLinePackageList",
                        method: "GET",
                        params: {
                            lineCode: localStorage.getItem("whCode") || "",
                            fcCode: localStorage.getItem("fcCode") || "", //	当前登录的工厂
                            lpType: "20"
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.packingMethodList = res.data;
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
            },

            /**
             * 新增成品 多选
             */
            selectAllProdTaskDetail(val) {
                this.checkDetailList = val;
            },
            /**
             * 查询最近的工单
             */
            getOrderProductList() {
                if(this.productData.whCode == "CH"){
                    this.productData.whCode = "01,04,26,27"
                }
                this.$http
                    .request({
                        url: "/api/orderProduct/getOrderProductList",
                        method: "GET",
                        params: {
                            whCode: this.productData.whCode || null,
                            fcCode: localStorage.getItem("fcCode") || "", //	当前登录的工厂
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.orderList = res.data;
                            this.orderList.forEach((item)=>{
                                item.schduleStartDate = item.schduleStartDate.split(" ")[0];
                            })
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                        if(this.productData.whCode == "01,04,26,27"){
                            this.productData.whCode = "CH";
                        }                 
                    });
            },
            /**
             * 新增成品箱数据
             */
            insertProduct() {
                if (this.productData.opCode == "") {
                    this.$message({
                        message: "请选择工单编号！",
                        type: "warning",
                    });
                    return;
                } else if (this.productData.packCode == "") {
                    this.$message({
                        message: "请选择箱编号！",
                        type: "warning",
                    });
                    return;
                } else if (this.productData.packageCode == "") {
                    this.$message({
                        message: "请选择包装编号！",
                        type: "warning",
                    });
                    return;
                } else if (this.productData.matQuan == "") {
                    this.$message({
                        message: "请输入成品数量！",
                        type: "warning",
                    });
                    return;
                } else if (this.productData.boxNumber == 0) {
                    this.$message({
                        message: "箱数不能为0！",
                        type: "warning",
                    });
                    return;
                } else if (this.productData.boxNumber > 5) {
                    this.$message({
                        message: "箱数不能超过5箱！",
                        type: "warning",
                    });
                    return;
                } else {
                    this.productLoading = true;

                    let opData = this.orderList.find(o => o.opCode == this.productData.opCode)

                    this.$http
                        .request({
                            url: "/api/prodTask/insertProdTaskDetailList",
                            method: "POST",
                            showLoading: true,
                            params: {
                                boxNumber: this.productData.boxNumber || null,
                                // opCode: this.productData.opCode || null,
                                // packCode: this.productData.packCode || null,
                                // packageCode: this.productData.packageCode || null,
                                // whCode: this.productData.whCode || null,
                                // matQuan: this.productData.matQuan || null,
                                // matSpecs: this.productData.matSpecs || null,
                                // fcCode: localStorage.getItem("fcCode") || "", //	当前登录的工厂
                            },
                            data: this.productData,
                        })
                        .then((res) => {
                            if (res.status == 100) {
                                this.productLoading = false;
                                this.getProdTaskDetailByCreate();
                                this.closeProductDialog();
                                this.$message({
                                    message: "新增成功！",
                                    type: "success",
                                });

                                var returnData = res.data;

                                returnData.forEach((item) => {
                                    //打印成品标签
                                    var produceTime = moment().format("YYYYMMDD");

                                    var batchNo = 'P' + item.opCode;

                                    if (item.matSpecs == undefined) {
                                        item.matSpecs = "";
                                    }

                                    //T/生产工单/箱号/物料号/数量/规值/批次/生产日期/高度/箱型
                                    // var qrCode = "T/" + item.opCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                                    //     item.matQuan + "/" + item.matSpecs + "/" + batchNo +
                                    //     "/" + produceTime + "/" + "" + item.packCode;

                                    //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                                    var qrCode = item.boxBarcode + "," + item.opCode + "," + item.whCode + "," +
                                        item.matCode + "," + item.matQuan + "," + item.matSpecs +
                                        "," + batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                                    var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                                    var barcodeData = {
                                        boxBarcode: item.boxBarcode,
                                        prodCode: item.matCode,
                                        prodName: item.matName,
                                        batchNo: batchNo,
                                        count: item.matQuan,
                                        checkPerson: localStorage.getItem("empNumber"),
                                        date: produceTime,
                                        poCode: item.opCode,
                                        matSpecs: item.matSpecs,
                                        whCode: item.whCode,
                                        qrCode: qrCode,
                                        supply: "",
                                        printTime: printTime,
                                        packageCode: item.packageCode,
                                        packCode: item.packCode,
                                        com: item.com,
                                    }


                                    this.$printer.printWMSProductBarcode(barcodeData);
                                })

                            } else {
                                this.productLoading = false;
                                this.$message({
                                    message: res.message,
                                    type: "error",
                                });
                            }
                        });
                }
            },
            /**
             * 获取成品任务明细信息创建状态的数据
             */
            getProdTaskDetailByCreate() {
                this.$http
                    .request({
                        url: "/api/prodTask/getProdTaskDetailList",
                        method: "GET",
                        params: {
                            whCode: this.productData.whCode || null,
                            fcCode: localStorage.getItem("fcCode") || "", //	当前登录的工厂
                            status: "CREATE", //状态
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.prodTaskDetails.data = res.data.list || [];
                            this.prodTaskDetails.total = res.data.total;
                        } else {
                            this.$message({
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
            },
            /**
             * 打开新增成品箱窗口
             */
            openProductDialog() {
                this.getOrderProductList();
                this.enclosureCode();
                this.packingMethod();
                if(this.fcCode == "SXC"){
                    this.shipping = "agv";
                }
                this.insertProductDialog = true;
            },
            /**
             * 关闭新增成品箱窗口
             */
            closeProductDialog() {
                this.insertProductDialog = false;
                //this.productData.opCodeAndMatCode = "";
                this.productData.opCode = "";
                this.productData.matQuan = "";
                this.productData.packCode = "";
                this.productData.packageCode = "";
                this.productData.matSpecs = "";
                this.productData.boxNumber = "";
                this.orderList = [];
                if(this.fcCode == "SXC"){
                    this.shipping = "agv";
                }
                this.showMatSpecs = false;
            },
            /**
             * 定时器
             */
            /**
             * 打开包材上线窗口
             */
            openPackingMaterialDialog() {
                this.getLcCodeAllByWhCode();
                this.packingMaterialDialog = true;
            },
            /**
             * 关闭包材上线窗口
             */
            closePackingMaterialDialog() {
                this.packingMaterialDialog = false;
                this.packageCode = "";
                this.packageType = "";
                this.sysLineRouterList = [];
            },
            /**
             * 根据用户的工厂编号和通道编号查询所在的产线也就是库位编号
             */
            getLcCodeAllByWhCode() {
                this.$http
                    .request({
                        url: "/api/sysLineRouter/getLcCodeAllByPackage",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: localStorage.getItem("whCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.sysLineRouterList = resp.data || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            /**
             * 开始创建包材上线任务
             */
            emptyBoxOnline() {
                if (this.packageCode == "") {
                    this.$message({
                        message: "请选择库位编号！",
                        type: "warning",
                    });
                    return;
                } else if (this.packageType == "") {
                    this.$message({
                        message: "请选择所需的包材类型",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$confirm("是否确认开始执行包材上线任务?", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.insertPackageTask = true;
                            this.$http
                                .request({
                                    url: "/agv/taskWhole/emptyBoxOnline",
                                    method: "POST",
                                    params: {
                                        startPoint: this.packageCode || null,
                                        prodCode: this.packageType || null,
                                    },
                                    data: this.prodTaskDetails,
                                })
                                .then((resp) => {
                                    if (resp.status == 100) {
                                        this.closePackingMaterialDialog();
                                        this.getProdTaskByProductType();

                                        this.$message({
                                            message: "新增包材上线任务成功!",
                                            type: "success",
                                        });

                                        this.logRemarks = "splitMergeMatChange：新增包材上线任务成功";
                                    } else {
                                        this.$message({
                                            message: resp.message,
                                            type: "error",
                                        });
                                        this.logRemarks = "splitMergeMatChange：新增包材上线任务成功";
                                    }
                                    this.insertPackageTask = false;
                                    this.systemLog();
                                });
                        })
                        .catch(() => {
                            this.insertPackageTask = false;
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });
                }
            },
            /**
             * 取消任务执行
             */
            cancelTask() {
                var flag = false;
                this.checkList.forEach((item) => {
                    if (item.taskStatus == 'CANCEL') {
                        flag = true;
                    }
                })
                if (this.checkList.length < 1) {
                    this.$message({
                        message: "请勾选一个任务再进行取消任务操作！",
                        type: "warning",
                    });
                    return;
                } else if (this.checkList.length != 1) {
                    this.$message({
                        message: "只能对一个成品搬运任务进行取消任务！",
                        type: "warning",
                    });
                    return;
                } else if(this.checkList[0].taskStatus != 'START' && this.checkList[0].taskStatus != "EXECUTE"){
                    this.$message({
                        message: "只能对开始和进行中状态的任务进行取消任务！",
                        type: "warning",
                    });
                    return;
                }
                if (flag) {
                    this.$message({
                        message: "选中的任务已经取消任务无需再次取消！",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$confirm("是否确认取消该成品搬运任务?", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.$http
                                .request({
                                    url: "/agv/task/cancelTask",
                                    method: "PUT",
                                    showLoading: true,
                                    params: {
                                        taskCode: this.checkList[0].taskCode || null,
                                    },
                                })
                                .then((resp) => {
                                    if (resp.status == 100) {
                                        this.getProdTaskByProductType();
                                        this.$message({
                                            message: "取消成品搬运任务成功!",
                                            type: "success",
                                        });
                                        this.logRemarks = "splitMergeMatChange：取消成品搬运任务成功";
                                    } else {
                                        this.$message({
                                            message: resp.message,
                                            type: "error",
                                        });
                                        this.logRemarks = "splitMergeMatChange：取消成品搬运任务失败";
                                    }
                                    this.logContent = "taskCode：" + this.checkList[0].taskCode
                                    this.systemLog();
                                });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });
                }
            },
            // 根据任务编号获取所有的明细数据
            getProdTaskDetailList() {
                this.$http
                    .request({
                        url: "/api/prodTask/getProdTaskDetailByTaskCode",
                        method: "GET",
                        params: {
                            pageNum: this.prodTaskDetailData.pageNum,
                            pageSize: this.prodTaskDetailData.pageSize,
                            taskCode: this.taskCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.prodTaskDetailData.data = resp.data.list;
                            this.prodTaskDetailData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 获取所有的成品产线点的下料口
             */
            getSysLineRouterOutPuts() {
                this.$http
                    .request({
                        url: "/api/sysLineRouter/getLcCodeAllByWhCodeOutPut",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: localStorage.getItem("whCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.sysLineRouterOutPuts = resp.data || [];
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            chooseDTChange() {
                this.$forceUpdate();
            },
            //删除成品装车的物料
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            // 点击查询按钮 重置页号
            clickSelectList(newVal) {
                this.prodTaskData.pageNum = 1;
                this.getProdTaskByProductType(newVal);
            },
            /**
             * 获取所有的成品搬运任务记录
             */
            getProdTaskByProductType() {
                var taskStatus = "";
                //对任务状态进行处理
                this.taskStatusList.forEach((item) => {
                    taskStatus += item + ","
                })
                this.$http
                    .request({
                        url: "/api/prodTask/getProdTaskByProductType",
                        method: "GET",
                        params: {
                            pageNum: this.prodTaskData.pageNum || null,
                            pageSize: this.prodTaskData.pageSize || null,
                            fcCode: this.prodTaskSearch.fcCode || null,
                            lineCode: this.prodTaskSearch.lineCode || null,
                            taskStatus: taskStatus || null,
                            beginTime: this.prodTaskSearch.date ?
                                this.prodTaskSearch.date[0] : null,
                            endTime: this.prodTaskSearch.date ?
                                this.prodTaskSearch.date[1] : null,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.prodTaskData.data = resp.data.list || [];
                            this.prodTaskData.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /**
             * 新增成品搬运任务
             */
            insertProdTask: function() {
                this.handlingRules.forEach((item) => {
                    if (item.type == this.prBoxType) {
                        this.boxTypeData = item;
                    }
                })
                if (this.checkDetailList.length < 1) {
                    this.$message({
                        message: "请至少选择一箱成品箱再进行成品搬运！",
                        type: "warning",
                    });
                    return;
                } else if (this.lineCode == "" && this.fcCode == "SXC") {
                    this.$message({
                        message: "请选择库位编号！",
                        type: "warning",
                    });
                    return;
                } else if (this.prBoxType == "") {
                    this.$message({
                        message: "请选择箱体类型！",
                        type: "warning",
                    });
                    return;
                } else if (this.shipping == "") {
                    this.$message({
                        message: "请选择一种配送方式！",
                        type: "warning",
                    });
                    return;
                } else if ((this.checkDetailList.length != this.boxTypeData.number) && this.boxTypeData.type != 'CC' && this.shipping == 'agv') {
                    this.$message({
                        message: "AGV搬运只能对" + this.boxTypeData.name + "进行" + this.boxTypeData.number + "托成品搬运！",
                        type: "warning",
                    });
                    return;
                } else {
                    this.$confirm("是否确认开始执行成品搬运任务?", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.insertProdTasks = true;
                            var url = "";
                            if(this.fcCode == 'SXC'){
                                url = "/agv/taskWhole/createFinishedOfflineTask";
                            }else{
                                url = "/api/prodTask/createFinishedOfflineTask";
                            }
                            this.$http
                                .request({
                                    url: url,
                                    method: "POST",
                                    params: {
                                        startPoint: this.lineCode || null,
                                        prBoxType: this.prBoxType || null,
                                        shipping: this.shipping || null,
                                    },
                                    data: this.checkDetailList,
                                })
                                .then((resp) => {
                                    if (resp.status == 100) {
                                        this.insertProdTaskDialog = false;
                                        this.prodTaskDetails.data = [];
                                        this.lineCode = "";
                                        this.boxBarcode = "";
                                        this.prBoxType = "";
                                        this.getProdTaskByProductType();
                                        if (resp.data == "artificial") {
                                            this.$message({
                                                message: "人工开始配送!",
                                                type: "success",
                                            });
                                        } else {
                                            this.$message({
                                                message: "新增成品搬运任务成功!",
                                                type: "success",
                                            });
                                        }
                                        this.logRemarks = "splitMergeMatChange：新增成品搬运任务成功";
                                    } else {
                                        this.$message({
                                            message: resp.message,
                                            type: "error",
                                        });
                                        this.logRemarks = "splitMergeMatChange：新增成品搬运任务失败";
                                    }
                                    this.insertProdTasks = false;
                                    this.systemLog();
                                });
                        })
                        .catch(() => {
                            this.insertProdTasks = false;
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });
                }
            },
            /**
             * 根据工厂编号查询所有的来源通道
             */
            getSysWarehouseAll() {
                this.$http
                    .request({
                        url: "/api/warehouse/getWarehouse",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.warehouseList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            /**
             * 明细成品装车窗口
             */
            showProdTaskDetailDialog(taskCode) {
                this.prodTaskDetailDialog = true;
                this.taskCode = taskCode;
                this.getProdTaskDetailList();
            },
            /**
             * 关闭成品搬运明细窗口
             */
            returnClose() {
                this.prodTaskDetailDialog = false;
            },
            /**
             * 新增成品搬运窗口
             */
            showInsertProdTaskDialog() {
                this.getProdTaskDetailByCreate();
                this.getSysLineRouterOutPuts();
                this.getWhAreaByWhCode();
                this.insertProdTaskDialog = true;
                if(this.fcCode == "DLN"){
                    this.shipping = "artificial"
                }
                //this.prodTaskDetailData.pageNum = 1;
                //this.getSysWarehouseAll();
                //this.getProdTaskDetailList();
            },
            /**
             * 关闭成品搬运窗口
             */
            closeProdTaskDetailDialog() {
                this.insertProdTaskDialog = false;
                //this.prodTaskDetailData.pageNum = 1;
                //this.prodTaskDetails = [];
                this.lineCode = "";
                this.boxBarcode = "";
                this.prBoxType = "";
            },
            /* 点击解绑和占用按钮查询数据 */
            untieOccupyClick() {
                this.untieOccupyDialog = true;
                this.$http
                    .request({
                        url: "/api/sysLineRouter/getSysLineRouterAllByWhCode",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            whCode: localStorage.getItem("whCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.untieOccupyData.data = resp.data
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            /**
             * 判断点位是否存在任务
             */
            getProdTaskByLineRouterOccupy(){
                this.$http
                    .request({
                        url: "/api/prodTask/getProdTaskByLineRouter",
                        method: "GET",
                        showLoading: true,
                        params: {
                            lrCode: this.untieOccupyRadio,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.prodTaskLoading = "该点位还存在正在搬运的任务，是否确定占用和解绑？";   
                        } else if(res.status == 101){
                            this.prodTaskLoading = "是否对该点位进行占用和解绑操作？";
                        } else {
                            this.$message.error(res.message);
                        }
                        this.clickOccupyClick();
                    });
            },
            /* 点位的占用 */
            occupyClick() {
                this.getProdTaskByLineRouterOccupy();
            },
            clickOccupyClick(){
                if (this.untieOccupyRadio) {
                    this.$confirm(this.prodTaskLoading, "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.$http
                                .request({
                                    url: "/agv/pointrouter/occupyPoint",
                                    method: "POST",
                                    showLoading: true,
                                    params: {
                                        pointCode: this.untieOccupyRadio,
                                    },
                                })
                                .then((res) => {
                                    if (res.status == 100) {
                                        this.untieOccupyRadio = "";
                                        this.untieOccupyDialog = false;
                                        this.$message.success("点位占用成功!");
                                    } else if (res.status == 500) {
                                        this.$message.error('服务器异常!');
                                    } else {
                                        this.$message.error(res.message);
                                    }
                                });                                
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });
                }  
                else {
                    this.$message.error('请先选择点位!');
                }   
            },
            /**
             * 判断点位是否存在任务
             */
            getProdTaskByLineRouterUntie(){
                this.$http
                    .request({
                        url: "/api/prodTask/getProdTaskByLineRouter",
                        method: "GET",
                        showLoading: true,
                        params: {
                            lrCode: this.untieOccupyRadio,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.prodTaskLoading = "该点位还存在正在搬运的任务，是否确定占用和解绑？";   
                        } else if(res.status == 101){
                            this.prodTaskLoading = "是否对该点位进行占用和解绑操作？";
                        } else {
                            this.$message.error(res.message);
                        }
                        this.clickUntieClick();
                    });
            },
            clickUntieClick(){
                if (this.untieOccupyRadio) {
                    this.$confirm(this.prodTaskLoading, "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.$http
                                .request({
                                    url: "/agv/pointrouter/removeOccupy",
                                    method: "POST",
                                    showLoading: true,
                                    params: {
                                        pointCode: this.untieOccupyRadio,
                                    },
                                })
                                .then((res) => {
                                    if (res.status == 100) {
                                        this.untieOccupyRadio = "";
                                        this.untieOccupyDialog = false;
                                        this.$message.success("点位解绑成功!");
                                    } else if (res.status == 500) {
                                        this.$message.error('服务器异常!');
                                    } else {
                                        this.$message.error(res.message);
                                    }
                                });
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });
                } else {
                    this.$message.error('请先选择点位!');
                }
            },
            /* 点位的解绑 */
            untieClick() {
                this.getProdTaskByLineRouterUntie();
            },
            /**
             * 回车提交
             */
            // submit() {
            //     var flag = true;
            //判断箱号是否重复输入
            //     this.prodTaskDetails.forEach((item) => {
            //         if (item.boxBarcode == this.boxBarcode) {
            //             flag = false;
            //             this.$message({
            //                 message: "成品搬运的箱号相同",
            //                 type: "warning",
            //             });
            //             return;
            //         }
            //     })
            //     if (flag) {
            //         this.prodTaskDetails.push({
            //             boxBarcode: this.boxBarcode,
            //         });
            //         this.boxBarcode = "";
            //     }
            // },
            /**
             * 多选
             */
            selectAllProdTask(val) {
                this.checkList = val;
            },
            /**
             * 多选
             */
            checkTableMain(val) {
                this.checkListMain = val;
            },
            //清空成品搬运条件
            ProdTaskReset() {
                this.prodTaskSearch = {
                    fcCode: localStorage.getItem("fcCode") || "",
                    lineCode: localStorage.getItem("whCode") || "",
                    taskStatus: "",
                    date: [],
                };
                this.taskStatusList = ["START", "EXECUTE"];
                this.getProdTaskByProductType();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var taskStatus = "";
                this.taskStatusList.forEach((item) => {
                    taskStatus += item + ","
                })
                var paramsObj = {
                    fcCode: this.prodTaskSearch.fcCode || null,
                    lineCode: this.prodTaskSearch.lineCode || null,
                    taskStatus: taskStatus || null,
                    beginTime: this.prodTaskSearch.date ? this.prodTaskSearch.date[0] : null,
                    endTime: this.prodTaskSearch.date ? this.prodTaskSearch.date[1] : null,
                    pageNum: 1,
                    pageSize: 999999,

                }
                this.$http.request({
                    url: '/api/prodTask/getProdTaskByProductType',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.agvFlag == true) {
                            c['agvFlag'] = '是'
                        } else if (c.agvFlag == false) {
                            c['agvFlag'] = '否'
                        }

                        if (c.taskType == 'PRODUCT') {
                            c['taskType'] = '成品下线'
                        } else if (c.taskType == 'EMPTYBOX') {
                            c['taskType'] = '包材上线'
                        } else if (c.taskType == 'POINTPULL') {
                            c['taskType'] = '点对点搬运'
                        }

                        if (c.taskStatus == 'START') {
                            c['taskStatus'] = '任务开始'
                        } else if (c.taskStatus == 'EXECUTE') {
                            c['taskStatus'] = '任务进行中'
                        } else if (c.taskStatus == 'CANCEL') {
                            c['taskStatus'] = '任务取消'
                        } else if (c.taskStatus == 'COMPLETE') {
                            c['taskStatus'] = '任务正常完成'
                        } else if (c.taskStatus == 'WARNCOMP') {
                            c['taskStatus'] = '任务异常完成'
                        }

                        if (c.boxType == 'AA') {
                            c['boxType'] = '一期成品二层箱'
                        } else if (c.boxType == 'BB') {
                            c['boxType'] = '一期成品一层箱'
                        } else if (c.boxType == 'CC') {
                            c['boxType'] = '大托盘'
                        } else if (c.boxType == 'DD') {
                            c['boxType'] = '二期蓝色一层箱'
                        } else if (c.boxType == 'EE') {
                            c['boxType'] = '二期成品二层箱'
                        } else if (c.boxType == 'FF                                                                                                  ') {
                            c['boxType'] = '二期成品一层箱'
                        }


                    })
                    const tHeader = ['来源通道', '任务编号', '任务类型', '任务状态', '当前任务描述', '任务执行点', '任务终点', 'AGV是否接收任务', '创建时间', '物料编号', '箱体类型', '容器类型']
                    const filterVal = ['lineCode', 'taskCode', 'taskType', 'taskStatus', 'nowTcDesc', 'taskPathPoint', 'taskFinishPoint', 'agvFlag', 'createTime', 'prodCode', 'boxType', 'cntrType']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '成品搬运'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "product_pull：导出成品搬运记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "成品搬运",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                    })
                    .catch((error) => {});
            },
            openTime(){
                this.timer = setInterval(() => {
                    this.clickSelectList();
                }, 20000);
            }
        },
        activated(){
            /* 获取首页的数据 */
            //this.getProdTaskDetailByCreate();
            this.getProdTaskByProductType();
            this.getSysWarehouseAll();
            this.openTime();
        },
        deactivated(){
            clearTimeout(this.timer);
        },
    };
</script>

<style scoped>
</style>